export const usePlausible = () => {
  return (event: string, props?: Record<string, unknown>) => {
    // Mock implementation - replace with actual Plausible integration
    console.log("Plausible event:", event, props);
  };
};
